@let item = media();
@if (item?.url) {
    <img
        [src]="item!.url | addStrapiDomainName"
        [alt]="item!.alternativeText || fallbackAlt()"
        [width]="item!.width"
        [height]="item!.height"
        [attr.loading]="loading()"
        [attr.srcset]="srcset()"
        [attr.sizes]="srcset() ? sizes() : null"
    />
}
